import { LutronDesignerMessageType } from "../../models";
import AggregatedLogger from "../../observability/AggregatedLogger/AggregatedLogger";

import WebViewClient, { WebViewMessage } from "./WebViewClient";

export interface OpenArtifactRequest extends WebViewMessage {
  type: LutronDesignerMessageType.OpenArtifactRequest;
  payload: {
    artifactID: string;
    etag: string;
    guiGuid: string;
    guiMD5: string;
    lastModified: string;
    artifactHref: string;
    orchestratorPayload: string;
  };
}

export interface CreateArtifactRequest {
  type: LutronDesignerMessageType.CreateArtifactRequest;
}

export interface OpenLocalRequest {
  type: LutronDesignerMessageType.OpenLocalRequest;
}

export interface MigrateToAthenaRequest {
  type: LutronDesignerMessageType.MigrateToAthenaRequest;
  payload: {
    artifactID: string;
    artifactHref: string;
  };
}

/*
  Lutron Designer Client communicates with the Green GUI
*/
export default class LutronDesignerClient extends WebViewClient {
  public static openArtifactRequest(payload: OpenArtifactRequest["payload"]) {
    this.postMessage({
      type: LutronDesignerMessageType.OpenArtifactRequest,
      payload,
    });
    AggregatedLogger.log(
      `sent ${LutronDesignerMessageType.OpenArtifactRequest}`,
      payload,
    );
  }

  public static createArtifactRequest() {
    this.postMessage({
      type: LutronDesignerMessageType.CreateArtifactRequest,
    });
    AggregatedLogger.log(
      `sent ${LutronDesignerMessageType.CreateArtifactRequest}`,
    );
  }

  public static openLocalRequest() {
    this.postMessage({
      type: LutronDesignerMessageType.OpenLocalRequest,
    });
    AggregatedLogger.log(`sent ${LutronDesignerMessageType.OpenLocalRequest}`);
  }

  public static migrateToAthenaRequest(
    payload: MigrateToAthenaRequest["payload"],
  ) {
    this.postMessage({
      type: LutronDesignerMessageType.MigrateToAthenaRequest,
      payload,
    });
    AggregatedLogger.log(
      `sent ${LutronDesignerMessageType.MigrateToAthenaRequest}`,
      payload,
    );
  }
}
